import axios from 'axios';

import { gboexResponseErrorServicos } from '../../helpers/response';

const baseAxios = axios.create({
    baseURL: process.env.REACT_APP_API_SERVICOS
});

baseAxios.interceptors.response.use(
    async (response) => response,
    async (error) => gboexResponseErrorServicos(error)
);

export default baseAxios;